export interface Movie {
  id: string;
  title: string;
  cover: string;
  year: number;
  category: string;
  rating: number;
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateInfo: string;
  director: string;
  actors: string[];
  region: string;
  episodeInfo: string;
  detailContent: string;
  releaseDate: string;
  duration: string;
}

export const hotMovies: Movie[] = [
  {
    id: "movie-1",
    title: "流浪地球3",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20futuristic%20space%20station%20and%20Earth%20in%20background%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20dark%20tones%2C%20clean%20minimal%20background&width=600&height=800&seq=movie-cover-01&orientation=portrait",
    year: 2026,
    category: "movie",
    rating: 8.5,
    description: "太阳急速老化，持续膨胀，人类面临前所未有的生存危机。联合政府决定启动移山计划，在全球建造一万座行星发动机，带领地球踏上长达2500年的宇宙流浪之旅。",
    tags: ["科幻", "灾难", "冒险"],
    isHot: true,
    isNew: false,
    updateInfo: "HD1080P 中文字幕",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    region: "中国大陆",
    episodeInfo: "全1集",
    detailContent: "在太阳急速老化的危机下，人类被迫踏上长达2500年的宇宙流浪之旅。流浪地球3延续前作的故事线，讲述了人类在宇宙航行中面临的全新挑战。联合政府内部的矛盾、资源的日益枯竭、以及未知宇宙的威胁，都让这次流浪之旅充满变数。本片以宏大的视觉特效和深刻的人文关怀，展现了人类在绝境中的坚韧与团结。",
    releaseDate: "2026-07-15",
    duration: "148分钟",
  },
  {
    id: "movie-2",
    title: "满江红2",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20with%20ancient%20Chinese%20soldiers%20in%20red%20armor%2C%20dramatic%20cinematic%20lighting%2C%20dark%20moody%20background%2C%20epic%20composition&width=600&height=800&seq=movie-cover-02&orientation=portrait",
    year: 2026,
    category: "movie",
    rating: 8.8,
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。小兵张大与亲兵营副统领孙均被卷入一场惊天阴谋，层层反转，真相扑朔迷离。",
    tags: ["历史", "悬疑", "剧情"],
    isHot: true,
    isNew: false,
    updateInfo: "4K超清 中文字幕",
    director: "张艺谋",
    actors: ["沈腾", "易烊千玺", "张译"],
    region: "中国大陆",
    episodeInfo: "全1集",
    detailContent: "满江红2延续了前作紧张刺激的叙事风格，以南宋时期为背景，围绕一首传世名篇《满江红》展开更加错综复杂的权力斗争。影片通过精巧的多线叙事，将观众带入一个充满阴谋与忠诚、背叛与牺牲的历史迷雾之中。张艺谋导演再次展现了其独特的色彩美学和叙事功力。",
    releaseDate: "2026-05-20",
    duration: "156分钟",
  },
  {
    id: "movie-3",
    title: "哪吒之魔童闘海2",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%20featuring%20a%20mythological%20young%20hero%20with%20fire%20elements%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20epic%20cinematic%20lighting%2C%20dark%20dramatic%20background&width=600&height=800&seq=movie-cover-03&orientation=portrait",
    year: 2026,
    category: "movie",
    rating: 9.1,
    description: "天劫之后，哪吒和敖丙的灵魂保住了，但肉身却面临崩坏。太乙真人打算用七色宝莲为他们重塑肉身，然而更大的危机悄然逼近。",
    tags: ["动画", "奇幻", "冒险"],
    isHot: true,
    isNew: true,
    updateInfo: "IMAX版 国语中字",
    director: "饺子",
    actors: ["吕艳婷", "囧森瑟夫", "瀚墨"],
    region: "中国大陆",
    episodeInfo: "全1集",
    detailContent: "哪吒之魔童闘海2延续了前作的精彩故事。在经历了天劫之后，哪吒和敖丙虽然保住了灵魂，但肉身却岌岌可危。太乙真人带着七色宝莲前来相助，然而在重塑肉身的过程中，更大的危机正悄然逼近。东海龙王敖光对爱子之死耿耿于怀，誓要报仇雪恨。本片以绚丽的画风和深刻的情感内核，再次刷新了国产动画的高度。",
    releaseDate: "2026-02-10",
    duration: "133分钟",
  },
];

export const newEpisodes: Movie[] = [
  {
    id: "tv-1",
    title: "庆余年3",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20period%20TV%20drama%20poster%20with%20ancient%20Chinese%20court%20official%20in%20elegant%20robe%2C%20dramatic%20lighting%2C%20palace%20interior%20background%2C%20warm%20golden%20and%20dark%20tones&width=600&height=800&seq=movie-cover-04&orientation=portrait",
    year: 2026,
    category: "tv",
    rating: 8.9,
    description: "范闲率领使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，庆国朝堂风云再起，权谋斗争进入白热化阶段。",
    tags: ["古装", "权谋", "剧情"],
    isHot: true,
    isNew: true,
    updateInfo: "更新至第36集/共46集",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明"],
    region: "中国大陆",
    episodeInfo: "更新至第36集/共46集",
    detailContent: "庆余年第三季延续了范闲的传奇故事。在大东山事件之后，各方势力蠢蠢欲动。范闲必须面对更加复杂的政治局面，同时在个人情感与家国大义之间做出选择。本季剧情更加紧凑，人物关系更加错综复杂，每一个角色都面临着自己的命运抉择。陈道明饰演的庆帝与张若昀饰演的范闲之间的父子对决，成为本季最大的看点。",
    releaseDate: "2026-06-01",
    duration: "45分钟/集",
  },
  {
    id: "tv-2",
    title: "狂飙2：暗流",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20TV%20drama%20poster%20with%20police%20officer%20in%20dark%20suit%2C%20urban%20night%20scene%2C%20moody%20lighting%2C%20tense%20atmosphere%2C%20cinematic%20style&width=600&height=800&seq=movie-cover-05&orientation=portrait",
    year: 2026,
    category: "tv",
    rating: 9.0,
    description: "扫黑除恶常态化背景下，京海市政法队伍教育整顿持续深入，新的黑恶势力正在暗处滋生，安欣和他的同事们再次踏上征程。",
    tags: ["犯罪", "悬疑", "剧情"],
    isHot: false,
    isNew: true,
    updateInfo: "更新至第24集/共40集",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐"],
    region: "中国大陆",
    episodeInfo: "更新至第24集/共40集",
    detailContent: "狂飙2：暗流延续了前作扫黑除恶的主题，将故事背景设定在第一季事件发生五年之后。新的黑恶势力以更加隐蔽的方式渗透社会各个角落，安欣和他的同事们面临着前所未有的挑战。本季深入探讨了正义与邪恶在新时代背景下的较量，剧情环环相扣，悬念迭起。",
    releaseDate: "2026-07-08",
    duration: "45分钟/集",
  },
  {
    id: "tv-3",
    title: "唐朝诡事录之西行",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20mystery%20period%20TV%20drama%20poster%20with%20Tang%20dynasty%20detectives%2C%20ancient%20Chinese%20landscape%2C%20misty%20mountains%2C%20mysterious%20atmosphere%2C%20warm%20golden%20and%20dark%20green%20tones&width=600&height=800&seq=movie-cover-06&orientation=portrait",
    year: 2026,
    category: "tv",
    rating: 8.6,
    description: "大唐元和年间，苏无名与卢凌风再度联手，一路西行探案，揭开一桩桩离奇案件的真相，西域之行险象环生。",
    tags: ["古装", "悬疑", "探案"],
    isHot: false,
    isNew: true,
    updateInfo: "更新至第18集/共36集",
    director: "柏杉",
    actors: ["杨旭文", "杨志刚", "郜思雯"],
    region: "中国大陆",
    episodeInfo: "更新至第18集/共36集",
    detailContent: "唐朝诡事录之西行是唐朝诡事录系列的全新篇章。苏无名与卢凌风踏上西行之路，一路上遇到了各种匪夷所思的奇案。从西域古城的诅咒到丝绸之路上的神秘消失事件，每一个案件都融合了历史、民俗与悬疑元素。本季不仅延续了前作的诡异氛围，更在视觉呈现上有了质的飞跃。",
    releaseDate: "2026-06-25",
    duration: "45分钟/集",
  },
  {
    id: "movie-4",
    title: "封神第三部",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20epic%20movie%20poster%20with%20ancient%20warriors%20and%20magical%20creatures%2C%20dramatic%20clouds%20and%20lightning%2C%20grand%20cinematic%20scale%2C%20golden%20and%20crimson%20tones&width=600&height=800&seq=movie-cover-07&orientation=portrait",
    year: 2026,
    category: "movie",
    rating: 0,
    description: "商周大战全面爆发，姜子牙率领的西岐大军与纣王的殷商大军决战于牧野，封神大战进入最终章，诸神归位。",
    tags: ["奇幻", "史诗", "动作"],
    isHot: true,
    isNew: true,
    updateInfo: "即将上映 2026年暑期",
    director: "乌尔善",
    actors: ["黄渤", "费翔", "李雪健"],
    region: "中国大陆",
    episodeInfo: "即将上映",
    detailContent: "封神第三部是整个封神三部曲的收官之作。牧野之战将全面展开，姜子牙率领的西岐联军与殷商大军进行最后的决战。诸神归位，封神榜上的名字一个接一个被点亮。本片将以宏大的战争场面和震撼的视觉特效，为观众呈现中国神话史诗的终极篇章。每一个角色的命运都将在此画上句号。",
    releaseDate: "2026-08-01",
    duration: "160分钟",
  },
];

export const allMovies: Movie[] = [...hotMovies, ...newEpisodes];

export const categoryMovieMap: Record<string, Movie[]> = {
  movie: allMovies.filter((m) => m.category === "movie"),
  tv: allMovies.filter((m) => m.category === "tv"),
  anime: [
    {
      id: "anime-1",
      title: "斗破苍穹 年番2",
      cover: "https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%20with%20martial%20arts%20hero%20surrounded%20by%20flames%2C%20fantasy%20world%2C%20dynamic%20action%20pose%2C%20vibrant%20red%20and%20gold%20colors%2C%20dark%20background&width=600&height=800&seq=movie-cover-08&orientation=portrait",
      year: 2026,
      category: "anime",
      rating: 8.4,
      description: "萧炎在迦南学院经历了一系列的磨练，实力大增，即将面对更加严峻的挑战，魂殿的阴影笼罩着整片大陆。",
      tags: ["玄幻", "热血", "冒险"],
      isHot: false,
      isNew: true,
      updateInfo: "更新至第52集",
      director: "赵丙乐",
      actors: ["张沛", "冯骏骅", "杨梦露"],
      region: "中国大陆",
      episodeInfo: "更新至第52集",
      detailContent: "斗破苍穹年番第二季继续讲述萧炎的成长历程。在迦南学院中，萧炎凭借自己的努力和天赋，实力突飞猛进。然而，魂殿的阴影始终笼罩着这片大陆，更强大的敌人正在暗中酝酿着新的阴谋。本季动画制作更加精良，战斗场面燃爆全场。",
      releaseDate: "2026-01-15",
      duration: "20分钟/集",
    },
    {
      id: "anime-2",
      title: "凡人修仙传 仙界篇",
      cover: "https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20poster%20with%20immortal%20cultivator%20in%20flowing%20white%20robes%2C%20celestial%20mountain%20landscape%2C%20misty%20atmosphere%2C%20ethereal%20lighting%2C%20cool%20tones&width=600&height=800&seq=movie-cover-09&orientation=portrait",
      year: 2026,
      category: "anime",
      rating: 8.7,
      description: "韩立飞升仙界后，发现仙界并非想象中那般美好，危机四伏的仙界之旅即将开始，步步为营方得生存。",
      tags: ["修仙", "奇幻", "冒险"],
      isHot: true,
      isNew: false,
      updateInfo: "更新至第78集",
      director: "王裕仁",
      actors: ["钱文青", "杨天翔", "乔诗语"],
      region: "中国大陆",
      episodeInfo: "更新至第78集",
      detailContent: "韩立终于飞升仙界，却发现仙界之浩瀚远超想象。各方势力盘踞，危机四伏。初入仙界的韩立必须从头开始，在一个完全陌生的环境中步步为营。本片以精良的制作和紧凑的剧情，完美呈现了原著小说中波澜壮阔的仙界篇章。",
      releaseDate: "2025-09-20",
      duration: "22分钟/集",
    },
  ],
  variety: [
    {
      id: "variety-1",
      title: "奔跑吧 第十二季",
      cover: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20smiling%20and%20running%2C%20colorful%20vibrant%20design%2C%20outdoor%20sunny%20background%2C%20energetic%20atmosphere&width=600&height=800&seq=movie-cover-10&orientation=portrait",
      year: 2026,
      category: "variety",
      rating: 7.8,
      description: "王牌综艺重磅回归，全新阵容带来全新体验，搞笑与感动并存的户外真人秀，走遍全国各地欢乐不断。",
      tags: ["真人秀", "搞笑", "户外"],
      isHot: true,
      isNew: true,
      updateInfo: "更新至第8期",
      director: "姚译添",
      actors: ["李晨", "郑恺", "沙溢", "白鹿", "周深"],
      region: "中国大陆",
      episodeInfo: "更新至第8期",
      detailContent: "奔跑吧第十二季以全新的阵容和更有创意的游戏环节回归。本季节目走遍全国各地，在展现祖国大好河山的同时，为观众带来无数欢乐和感动。全新加入的成员带来了新鲜化学反应，让这档王牌综艺焕发新的活力。",
      releaseDate: "2026-07-03",
      duration: "90分钟/期",
    },
    {
      id: "variety-2",
      title: "歌手2026",
      cover: "https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%20with%20microphone%20and%20stage%20lights%2C%20dramatic%20spotlight%2C%20dark%20concert%20background%2C%20elegant%20design&width=600&height=800&seq=movie-cover-11&orientation=portrait",
      year: 2026,
      category: "variety",
      rating: 8.1,
      description: "华语乐坛顶级歌手同台竞技，用音乐诠释灵魂，每一场都是一次视听盛宴，原创挑战环节更是精彩纷呈。",
      tags: ["音乐", "竞技", "综艺"],
      isHot: false,
      isNew: true,
      updateInfo: "更新至第6期",
      director: "洪涛",
      actors: ["那英", "华晨宇", "邓紫棋", "周深", "毛不易"],
      region: "中国大陆",
      episodeInfo: "更新至第6期",
      detailContent: "歌手2026汇聚了华语乐坛最顶尖的实力唱将。每一位歌手都在这个舞台上挑战自我，用最纯粹的音乐打动观众。本季新增了原创歌曲挑战环节，让歌手们不仅要唱得好，还要展现创作才华。每一场竞演都是一次心灵的震撼。",
      releaseDate: "2026-06-14",
      duration: "120分钟/期",
    },
  ],
  documentary: [
    {
      id: "doc-1",
      title: "舌尖上的中国 第五季",
      cover: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20traditional%20Chinese%20cuisine%20dishes%2C%20steaming%20hot%20food%2C%20warm%20kitchen%20lighting%2C%20rustic%20wooden%20table%2C%20appetizing%20composition&width=600&height=800&seq=movie-cover-12&orientation=portrait",
      year: 2026,
      category: "documentary",
      rating: 9.3,
      description: "探寻中国各地最地道的美食文化，用镜头记录食物背后的人文故事和烟火气息，非遗美食传承篇。",
      tags: ["美食", "文化", "人文"],
      isHot: false,
      isNew: false,
      updateInfo: "全8集已完结",
      director: "陈晓卿",
      actors: ["李立宏（旁白）"],
      region: "中国大陆",
      episodeInfo: "全8集",
      detailContent: "舌尖上的中国第五季以更加细腻的视角，深入中国各地寻找最地道的美食。从东北的酸菜炖粉条到广东的煲仔饭，从四川的麻辣火锅到江南的精致点心，每一样美食背后都承载着一段动人的故事。本季特别关注了非遗美食的传承与创新。",
      releaseDate: "2025-12-20",
      duration: "50分钟/集",
    },
    {
      id: "doc-2",
      title: "航拍中国 第五季",
      cover: "https://readdy.ai/api/search-image?query=Chinese%20aerial%20documentary%20poster%20with%20stunning%20birds-eye%20view%20of%20Chinese%20landscapes%2C%20mountains%20and%20rivers%20from%20above%2C%20dramatic%20natural%20lighting%2C%20vast%20scale&width=600&height=800&seq=movie-cover-13&orientation=portrait",
      year: 2026,
      category: "documentary",
      rating: 9.4,
      description: "以全新空中视角俯瞰中国大地，展现壮丽山河与城市变迁的宏大画卷，西南地区的自然奇观令人叹为观止。",
      tags: ["自然", "地理", "航拍"],
      isHot: false,
      isNew: true,
      updateInfo: "更新至第5集/共10集",
      director: "余乐",
      actors: ["李龙滨（旁白）"],
      region: "中国大陆",
      episodeInfo: "更新至第5集/共10集",
      detailContent: "航拍中国第五季以更加先进的航拍技术，带领观众从空中俯瞰壮美的中国。本季聚焦了西南地区的壮丽山河，从青藏高原的雪域秘境到云南的热带雨林，从贵州的喀斯特地貌到四川的盆地风光，用独一无二的视角展现了中国大地的多样之美。",
      releaseDate: "2026-06-08",
      duration: "50分钟/集",
    },
  ],
};